import { matchPctTone } from './matchBadgeStyles';

function clampPct(value) {
  const n = Number(value);
  if (Number.isNaN(n) || n <= 0) return null;
  return Math.max(0, Math.min(100, Math.round(n)));
}

/** Human-readable relevance instead of raw floats / opaque scores. */
export function relevanceLabel(pct) {
  if (pct >= 80) return 'High Relevance';
  if (pct >= 50) return `${pct}% Match`;
  return 'Low Relevance';
}

export default function MatchBadge({ value, className = '' }) {
  const pct = clampPct(value);
  if (pct == null) return null;

  const tone = matchPctTone(pct);
  const label = relevanceLabel(pct);

  return (
    <span
      className={`inline-flex shrink-0 items-center rounded-md border px-2 py-0.5 text-[11px] font-semibold tracking-tight sm:text-xs ${tone.border} ${tone.bg} ${tone.text} ${tone.glow} ${className}`.trim()}
      aria-label={`${pct}% match — ${label}`}
      title={`${pct}% confidence`}
    >
      {label}
    </span>
  );
}
